import State from './state';

export function getParentTotalPoints(state) {
  return state.parent_total_points;
}

export function getParentPointsSum(state) {
  return state.parent_points_sum;
}

export function getParentPointsMean(state) {
  return state.parent_points_mean;
}

export function getParentPointsBySkill(state) {
  return state.parent_point_by_skill;
}

export function getParentPointsPerTime(state) {
  return state.parent_points_per_time;
}

export function getChildStarProgress(state) {
  return state.child_star_progress;
}

export function getChildStarProgressById(state) {
  return (childId) =>
    state.child_star_progress.find((star_progress) => star_progress.child === childId);
}

export function getChildGoalProgress(state) {
  return state.child_goals_progress;
}

export function getChildPoints(state) {
  return state.child_points;
}

export function getChildOwnStars(state) {
  return state.child_own_stars;
}

export function getChildGoals(state) {
  return state.child_goals;
}

export function getChildGoalsDisapproved(state) {
  return state.child_goals_disapproved;
}

export function getChildUniquePoints(state) {
  return state.child_unique_points;
}

export function parentPopups(state = State) {
  return state.popups.parent;
}

export function childPopups(state = State) {
  return state.popups.child;
}
